// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import VCalendar from 'v-calendar'
import io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import VueClipboard from 'vue-clipboard2'
import money from 'v-money'
import vSelect from 'vue-select'
import Vue2Filters from 'vue2-filters'
import vueAwesomeCountdown from 'vue-awesome-countdown'
import Multiselect from 'vue-multiselect'
// import VueTidio from 'vue-tidio'
import VueChatScroll from 'vue-chat-scroll'

import { router } from './router'
import store from './store'
import mixin from './mixin'
import Filters from './filters'

// const {
//   API_URL,
//   SOCKET_URL,
//   TIDIO_APPKEY
// } = process.env

const {
  API_URL,
  SOCKET_URL
} = process.env

axios.defaults.baseURL = `${API_URL}/api/v1/`

const token = localStorage.getItem('token')
// console.log('store.state', store.state.auth.token)
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue()

// use library here
Vue.use(vueAwesomeCountdown, 'vac')
Vue.use(BootstrapVue)
Vue.use(VueChatScroll)
// Vue.use(VeeValidate)
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})
Vue.use(VCalendar)
Vue.use(VueClipboard)
Vue.use(money, {
  decimal: '.',
  thousands: ',',
  precision: 0,
  masked: false
})
Vue.use(Vue2Filters)
Vue.component('multiselect', Multiselect)
Vue.component('v-select', vSelect)

VeeValidate.Validator.extend('verify_password', {
  getMessage: 'Please choose a stronger password. Try to use 8 or more characters with a mix of small and capital letters, and numbers.',
  validate: (value) => {
    // const strongRegex = new RegExp('^(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$')
    // eslint-disable-next-line no-useless-escape
    const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
    return strongRegex.test(value)
  }
})

// Socket here
const socketInstance = io(SOCKET_URL, {
  transports: ['websocket']
})

Vue.use(new VueSocketIO({
  debug: true,
  connection: socketInstance,
  vuex: {
    store,
    actionPrefix: 'WEBSOCKET_',
    mutationPrefix: 'WEBSOCKET_'
  }
}))

// Mixin For Global Function
Vue.mixin(mixin)
Vue.filter(Filters)

// Vue.use(VueTidio, { appKey: TIDIO_APPKEY })

new Vue({
  el: '#app',
  store,
  router,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  components: { App },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js